import React, {Component} from "react"
import PropTypes from "prop-types"
import {Button, ButtonGroup, Glyphicon, Panel} from 'react-bootstrap'
import ExamForm, {createExamInitialValues} from './ExamForm'
import * as Date from "../../utils/date"
import {ExamTypeLabel} from "../../utils/enums";
import {Enums} from "../../utils";
import type {ItemTableContext} from "./helpers";
import {formatItemActions, renderItemTable} from "./helpers";

class DogExams extends Component {

	tableCtx: ItemTableContext;

	constructor(props) {
		super(props)

		this.state = {
			itemModalOpen: false,
			examId: null
		}

		this.handleItemModalClick = this.handleItemModalClick.bind(this);
		this.handleItemModalDismiss = this.handleItemModalDismiss.bind(this);

		this.tableCtx = {
			itemKeyName: 'examId',
			cols: [
				{title: 'Datum', width: 17},
				{title: 'Typ', width: 17},
				{title: 'Popis', width: 39},
				{title: 'Provedl', width: 17},
			],
			renderRow: (item, files, props) => {
				const {enums} = props;
				return <tr key={item.examId} title={item.createdBy && Enums.getEnumTitle(enums, 'user', item.createdBy) + ' ' + Date.formatDateTime(item.createdAt)}>
					<td title={item.examId}>
						{Date.formatDate(item.examDate)}
					</td>
					<td>{ExamTypeLabel[item.examType]}</td>
					<td>{this.formatDescription(item)}</td>
					<td>{item.examBy && Enums.getEnumTitle(enums, 'user', item.examBy)}
						{item.examDoctor && ' (' + item.examDoctor + ')'}</td>
					<td>{formatItemActions(item, 'examId', files, this.handleItemModalClick)}</td>
				</tr>;
			},
		}
	}

	componentWillMount() {
		this.props.onFetchData(this.props.dogId)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.dogId !== this.props.dogId) {
			this.props.onFetchData(nextProps.dogId)
		}
	}

	handleItemModalClick(examId) {
		this.setState({itemModalOpen: true, examId})
	}

	handleItemModalDismiss() {
		this.setState({itemModalOpen: false, examId: null})
	}

	formatDescription(item) {
		const rows = [];
		if (item.examEvent) {
			rows.push(<div key={'examEvent'}><i>{item.examEvent}</i></div>);
		}
		if (item.examResult) {
			rows.push(<div key={'examResult'}>{item.examResult}</div>)
		}
		return <div title={JSON.stringify(item)}>{rows}</div>;
	}

	renderItemModal() {
		const {dogId, session} = this.props;
		const {itemModalOpen, examId} = this.state;
		if (!itemModalOpen) {
			return null
		}
		return <ExamForm exam={createExamInitialValues(examId, dogId, session)} modal={{
			onHide: this.handleItemModalDismiss,
			onSuccess: (item) => this.props.onFetchData(item.dogId, true)
		}}/>
	}

	render() {
		return <Panel>
			<Panel.Heading>
				<div className={'panel-title'}>
					Prohlídky
					<ButtonGroup className="pull-right">
						<Button type="button" className="btn-sm" onClick={() => this.handleItemModalClick(null)}><Glyphicon glyph="plus"/> Přidat</Button>
					</ButtonGroup>
				</div>
			</Panel.Heading>
			<Panel.Body>
				{renderItemTable(this.tableCtx, this.props)}
				{this.renderItemModal()}
			</Panel.Body>
		</Panel>
	}
}

DogExams.propTypes = {
	dogId: PropTypes.number.isRequired,
	files: PropTypes.array,
	onFetchData: PropTypes.func.isRequired,
	onShowModal: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
}

export default DogExams



// WEBPACK FOOTER //
// ./src/components/dog/DogExams.js